export default __webpack_public_path__ + "img/uteplazarewards.png";